import { render } from "./JobSummaryCard.vue?vue&type=template&id=948b43bc&scoped=true"
import script from "./JobSummaryCard.vue?vue&type=script&lang=js"
export * from "./JobSummaryCard.vue?vue&type=script&lang=js"

import "./JobSummaryCard.vue?vue&type=style&index=0&id=948b43bc&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-948b43bc"]])

export default __exports__